// Change nav on scroll
window.addEventListener('scroll', function () {
    let mainNavigation = document.querySelector('#navigation_1');
    let logoNavigation = document.querySelector('.navigation_1_logo > a > img');
    let itemNavigation = document.querySelectorAll('.navigation_1_nav_item a');

    if(window.pageYOffset > 0) {
        mainNavigation.classList.add('scrolling-active');
        logoNavigation.classList.add('logo_scrolling_active');
        itemNavigation.forEach(item => {
           item.classList.add('nav_item_scrolling_active');
        });
    } else {
        mainNavigation.classList.remove('scrolling-active');
        logoNavigation.classList.remove('logo_scrolling_active');
        itemNavigation.forEach(item => {
            item.classList.remove('nav_item_scrolling_active');
        });
    }
});